import { Component } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError, ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';
import { HistoryTrackerService } from './services/history-tracker.service';

declare const gtag: Function;

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    standalone: false
})
export class AppComponent {
	loadingDataImg: boolean = false;
	public history: string[] = [];

	constructor(private router: Router,
		private activatedRoute: ActivatedRoute,
		private historyTrackerService: HistoryTrackerService) {
		router.events.subscribe(event => {
			this.navigationInterceptor(event);
		});

		this.router.routeReuseStrategy.shouldReuseRoute = () => false;

		/** START : Code to Track Page View using gtag.js */
		this.router.events.pipe(
			filter((event): event is NavigationEnd => event instanceof NavigationEnd)
		).subscribe((event) => {
			this.historyTrackerService.AddUrlHistory(event.urlAfterRedirects);

			gtag('event', 'page_view', {
				page_path: event.urlAfterRedirects
			})
		});
		/** END : Code to Track Page View  using gtag.js */
	}

	// Shows and hides the loading spinner during RouterEvent changes
	navigationInterceptor(event: any): void {
		//Triggered When the navigation starts
		if (event instanceof NavigationStart) {
			this.loadingDataImg = true;
		}
		//Triggered When the navigation ends
		if (event instanceof NavigationEnd) {
			this.loadingDataImg = false;
		}
		
		// Set loading state to false in both of the below events to hide the spinner in case a request fails
		if (event instanceof NavigationCancel) {
			this.loadingDataImg = false;
		}
		//Triggered When the error occurrs while navigation
		if (event instanceof NavigationError) {
			this.loadingDataImg = false;
		}
	}
}
